/**
 * Walidacja pól zarządcy — LUSTRO `backend/src/utils/clientFields.js`.
 *
 * Front sprawdza to samo co backend, żeby użytkownik dostał komunikat PRZY POLU,
 * zanim poleci żądanie. Backend i tak waliduje ponownie (jest jedynym strażnikiem
 * danych) — ta kopia jest wyłącznie dla wygody, nie zastępuje serwera.
 * Zmieniasz regułę tutaj → zmień ją także po stronie backendu (i odwrotnie).
 */

const NIP_DIGITS = 10;
const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

/** Zostawia same cyfry (usuwa spacje, myślniki, kropki). */
export function normalizeNip(raw: string): string {
  return (raw ?? '').replace(/[\s.-]/g, '');
}

/** @returns komunikat błędu albo null, gdy pole jest poprawne (puste = poprawne). */
export function nipError(raw: string): string | null {
  const asText = (raw ?? '').trim();
  if (asText === '') return null;
  const digits = normalizeNip(asText);
  if (!/^\d+$/.test(digits)) {
    return 'NIP może zawierać tylko cyfry (dopuszczalne spacje i myślniki).';
  }
  if (digits.length !== NIP_DIGITS) {
    return `NIP musi mieć ${NIP_DIGITS} cyfr (podano ${digits.length}).`;
  }
  return null;
}

/** @returns komunikat błędu albo null (puste = poprawne, pole jest opcjonalne). */
export function emailError(raw: string): string | null {
  const asText = (raw ?? '').trim();
  if (asText === '') return null;
  if (!EMAIL_RE.test(asText)) {
    return 'Nieprawidłowy adres e-mail (oczekiwany format: nazwa@domena.pl).';
  }
  return null;
}
